import {
    DEALERACCOUNTNUMBER_SUCCESS,
    DEALERACCOUNTNUMBER_FAILED,
    RESET_DEALERACCOUNTNUMBER,
    LOADING_DEALERACCOUNTNUMBER,
    NETWORK_ERROR_DEALERACCOUNTNUMBER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERACCOUNTNUMBER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERACCOUNTNUMBER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERACCOUNTNUMBER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERACCOUNTNUMBER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERACCOUNTNUMBER:
            return (state = initialState);
        default:
            return state;
    }
};
